import { component as defineComponent } from 'flightjs';

var NotificationsCountUI = function() {
    this.after('initialize', function() {
        this.on(this.$node, 'dataNotificationsCount', this.setNotifications);
        this.trigger(this.$node, 'uiNeedsNotificationsCount');
    });

    this.setNotifications = function(e, data) {
        if (data.count > 0) {
            this.$node.html('<span class="pill pill--notification">' + data.count + '</span>');
        }
    };
};

export default defineComponent(NotificationsCountUI);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/notifications-count.js